import React from 'react';
import { InputNumber, Select, Button, DatePicker } from 'antd';
import { SearchOutlined, DownloadOutlined } from '@ant-design/icons';
import type { Dayjs } from 'dayjs';

interface QueryParamsProps {
  year: number;
  month: number;
  transferDate: Dayjs | null;
  loading: boolean;
  exporting: boolean;
  onYearChange: (v: number | null) => void;
  onMonthChange: (v: string) => void;
  onTransferDateChange: (v: Dayjs | null) => void;
  onQuery: () => void;
  onExport: () => void;
}

const monthOptions = Array.from({ length: 12 }, (_, i) => ({
  value: String(i + 1).padStart(2, '0'),
  label: String(i + 1).padStart(2, '0'),
}));

const QueryParams: React.FC<QueryParamsProps> = ({
  year, month, transferDate, loading, exporting,
  onYearChange, onMonthChange, onTransferDateChange, onQuery, onExport,
}) => {
  return (
    <div className="bg-gray-50 border border-gray-200 rounded p-4 mb-4">
      {/* Row 1: Year/Month */}
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 80 }}>年度月份:</span>
          <InputNumber
            value={year}
            onChange={onYearChange}
            min={1990}
            max={2099}
            style={{ width: 100 }}
          />
          <span className="text-sm">年</span>
          <Select
            value={String(month).padStart(2, '0')}
            onChange={onMonthChange}
            options={monthOptions}
            style={{ width: 80 }}
          />
          <span className="text-sm">月</span>
        </div>
      </div>

      {/* Row 2: Transfer date */}
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 80 }}>轉帳日期:</span>
          <DatePicker
            value={transferDate}
            onChange={onTransferDateChange}
            style={{ width: 160 }}
            placeholder="選擇轉帳日期"
          />
        </div>
      </div>

      {/* Buttons */}
      <div className="flex gap-2">
        <Button
          type="primary"
          icon={<SearchOutlined />}
          onClick={onQuery}
          loading={loading}
        >
          查詢
        </Button>
        <Button
          icon={<DownloadOutlined />}
          onClick={onExport}
          loading={exporting}
          disabled={!transferDate}
        >
          匯出撥款檔
        </Button>
      </div>
    </div>
  );
};

export default QueryParams;
